import { http } from '@/api/_base';

const get_id = (inputId: string) => {
	return http.get('steam/steamid/' + inputId).then(response => {
		if (response.data['response']['success'] == 1) {
			return response.data['response']['steamid'];
		}
		return null;
	});
};

const get_library = (steamId: string) => {
	return http
		.get('steam/games/' + steamId)
		.then(response => {
			return {
				game_count: response.data['response']['game_count'],
				games: response.data['response']['games']
			};
		})
		.catch(error => {
			return null;
		});
};

export { get_id, get_library };
